import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { KontaktComponent } from './sider/kontakt/kontakt/kontakt.component';
import { LayoutComponent } from './ui/layout/layout.component';

const routes: Routes = [
  {
    path: '',
    // If this path is the 'full' match...
    pathMatch: 'full',
    // ...redirect to this route.
    redirectTo: 'forside',
  },
  {
    path: '',
    component: LayoutComponent,
    children: [
      // Here we will add our application pages
      {
        path: 'forside',
        loadChildren: () =>
          import('./sider/forside/forside.module').then((m) => m.ForsideModule),
      },
      {
        path: 'kundeservice',
        loadChildren: () =>
          import('./sider/kundeservice/kundeservice.module').then(
            (m) => m.KundeserviceModule
          ),
      },
      {
        path: 'bestemmelser',
        loadChildren: () =>
          import('./sider/bestemmelser/bestemmelser.module').then(
            (m) => m.BestemmelserModule
          ),
      },
      {
        path: 'om',
        loadChildren: () =>
          import('./sider/om/om.module').then((m) => m.OmModule),
      },
      { path: 'kontakt', component: KontaktComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
